import React from "react";
// in src/MyLayout.js
import { Layout } from "react-admin";
import Menu from "../Menu/CustomMenu";

const FZAdminLayout = (props) => <Layout {...props} menu={Menu} />;

export default FZAdminLayout;
